import AdminPage from "@/Pages/AdminPage/index.vue";
import ListarUsuariosPage from "@/Pages/AdminPage/Usuarios/ListarUsuariosPage.vue";
// import LoginPage from '@/Pages/LoginPage/index.vue';
import Caixas from "@/Pages/Caixas/index.vue";
import HomePage from "@/Pages/HomePage/index.vue";
import LoginPage from "@/Pages/LoginPage/index.vue";
import ResetPasswordPage from "@/Pages/LoginPage/ResetPasswordPage.vue";
import LogoutPage from "@/Pages/LogoutPage.vue";
import Vue from "vue";
import VueRouter from "vue-router";

import authService from "../Services/AuthService";
import acessoProfessor from "./acessoProfessor";
import acessoResponsavel from "./acessoResponsavel";
import agendas from "./agendas";
import alunos from "./alunos";
import auditoria from "./auditoria";
import aulas from "./aulas";
import autorizacoes from "./autorizacoes";
import avisos from "./avisos";
import circuitoNotas from "./circuito-notas";
import disciplinas from "./disciplinas";
import educacaoInclusiva from "./educacaoInclusiva";
import franquias from "./franquias";
import gestaoDeAulas from "./gestaoDeAulas";
import gestaoDeAulasAuxiliares from "./gestaoDeAulasAuxiliares";
import redirecionarSeForProfAuxiliar from "./guards/redirecionarSeForProfAuxiliar";
import redirecionarSeForProfessor from "./guards/redirecionarSeForProfessor";
import redirecionarSeForResponsavel from "./guards/redirecionarSeForResponsavel";
import inep from "./inep";
import matriculas from "./matriculas";
import mensalidades from "./mensalidades";
import notas from "./notas";
import notifiq from "./notifiq";
import planos from "./planos";
import professores from "./professores";
import relatorios from "./relatorios";
import series from "./series";
import turmas from "./turmas";
import usuarios from "./usuarios";
import historico from "./historico";
import calendarioLetivo from "./calendario-letivo";
import eventosCalendarioLetivo from "./eventos-calendario-letivo";
import bolsaFamilia from "./bolsa-familia";
import NaoAutorizado from "../Pages/NaoAutorizado.vue";
import fundeb from "./fundeb";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "login" },
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    beforeEnter(target, from, next) {
      if (authService.isLoggedIn()) {
        return next({ name: "home" });
      }
      return next();
    },
  },
  {
    path: "/home",
    name: "home",
    component: HomePage,
    beforeEnter: async (to, from, next) => {
      await redirecionarSeForResponsavel(to, from, next);
      await redirecionarSeForProfessor(to, from, next);
      await redirecionarSeForProfAuxiliar(to, from, next);
      return next();
    },
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: ResetPasswordPage,
    beforeEnter(target, from, next) {
      if (authService.isLoggedIn()) {
        return next({ name: "home" });
      }
      return next();
    },
  },
  {
    path: "/caixas",
    name: "caixas",
    component: Caixas,
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminPage,
    beforeEnter(to, from, next) {
      return next({ name: "home" });
    },
  },
  {
    path: "/admin/usuarios/listar",
    name: "admin.usuarios.listar",
    component: ListarUsuariosPage,
    beforeEnter(to, from, next) {
      return next({ name: "home" });
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: LogoutPage,
  },
  {
    path: "/nao-autorizado",
    name: "NaoAutorizado",
    component: NaoAutorizado,
  },
  ...mensalidades,
  ...franquias,
  ...turmas,
  ...series,
  ...disciplinas,
  ...alunos,
  ...auditoria,
  ...professores,
  ...matriculas,
  ...usuarios,
  ...inep,
  ...gestaoDeAulas,
  ...gestaoDeAulasAuxiliares,
  ...aulas,
  ...acessoProfessor,
  ...acessoResponsavel,
  ...notas,
  ...relatorios,
  ...educacaoInclusiva,
  ...avisos,
  ...agendas,
  ...notifiq,
  ...planos,
  ...circuitoNotas,
  ...autorizacoes,
  ...historico,
  ...calendarioLetivo,
  ...eventosCalendarioLetivo,
  ...bolsaFamilia,
  ...fundeb,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name !== "resetPassword" && to.name !== "login" && !authService.isLoggedIn())
    next({
      name: "login",
      query: {
        redirect: to.fullPath,
        name: to.name,
      },
    });
  else next();
});

export default router;
